import React from 'react'
import { Box, Button, Typography } from '@mui/material'
import { ChevronRight, Delete } from '@mui/icons-material'
import theme from './theme'

interface Props {
  onEdit: () => void
  onDuplicate: () => void
  onDelete: () => void
  isOpen: boolean
  canDelete: boolean
}

const FlightToolbar = ({ onEdit, onDuplicate, onDelete, isOpen, canDelete }: Props) => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'row',
        gap: theme.space['8'],
        justifyContent: 'space-between',
        width: '100%'
      }}
    >
      <Button variant="contained" size="small" color="secondary" title="Back">
        <ChevronRight
          sx={{
            color: theme.palette.text.primary,
            transform: isOpen ? 'rotate(90deg)' : 'rotate(0deg)'
          }}
        />
      </Button>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'row',
          gap: theme.space['8']
        }}
      >
        <Button color="secondary" variant="contained" onClick={onEdit} title="Edit">
          <Typography variant="ui-1" color={theme.palette['sage-900']}>
            Edit
          </Typography>
        </Button>
        <Button
          color="secondary"
          variant="contained"
          onClick={(e) => {
            e.stopPropagation()
            onDuplicate()
          }}
          title="Duplicate"
        >
          <Typography variant="ui-1" color={theme.palette['sage-900']}>
            Duplicate
          </Typography>
        </Button>
        <Button
          variant="contained"
          size="small"
          color="secondary"
          title="Delete"
          disabled={canDelete}
          onClick={onDelete}
        >
          <Delete
            fontSize="small"
            sx={{
              color: canDelete ? theme.palette['sage-300'] : theme.palette.text.primary
            }}
          />
        </Button>
      </Box>
    </Box>
  )
}

export default FlightToolbar
